import { User } from "types/User";
import { BaseService } from "./baseService";

class UserService extends BaseService<User> {
  controllerName = "user";
}

export const userService = new UserService();
